


import Sidebar from '../Sidebar/Sidebar';
import './DeviceReports.css'

import { Navigate, useNavigate } from 'react-router-dom';
import { FloatButton, Checkbox, Spin, Pagination, Empty, Modal, Input, Form, Button, message, Popconfirm, Row, Col, Divider, DatePicker, Tooltip, Select } from 'antd';
import { FilePdfOutlined, FileExcelOutlined, ExportOutlined, EyeOutlined, SwapOutlined, SortAscendingOutlined, SortDescendingOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useState, useEffect, useCallback } from 'react';
import search from '../Dashboard/assets/img/search.png';
import axios from 'axios';
import moment from 'moment';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import ResponsiveImageModal from './ResponsiveImageModal';
import { useMemo } from 'react';
const { RangePicker } = DatePicker;
const { Option } = Select;

function WebHookDeviceReports() {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkedItems, setCheckedItems] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [dateRange, setDateRange] = useState([null, null]);

  // States for Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalReports, setTotalReports] = useState(0);
  const [isGhlLoading, setIsGhlLoading] = useState(false);
  const [publishedReports, setPublishedReports] = useState([]);
  const reportsPerPage = 10;

  const [selectedFilter, setSelectedFilter] = useState('GV Post-Repair QC Testing with Datawipe');
  const [filterValue, setFilterValue] = useState('GV Post-Repair QC Testing with Datawipe');
  // States for Sorting
  const [sortOrder, setSortOrder] = useState('desc');

  // Cache for visited pages
  const [pageCache, setPageCache] = useState(new Map());

  // Debounce search
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [isImageModalVisible, setIsImageModalVisible] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const [imageError, setImageError] = useState('');
  const [kiostData, setKisokData] = useState([]);
  const [kioskChecked, setKioskChecked] = useState(false);
  const [blackbeltChecked, setBlackbeltChecked] = useState(false);
  const [activeFilter, setActiveFilter] = useState(""); // "kiosk" | "blackbelt" | ""
  const [pushReports, setPushReports] = useState([]);
  // Create cache key for current filters
  const getCacheKey = useCallback(() => {
    return `${currentPage}-${reportsPerPage}-${searchQuery}-${filterValue || ''}-${dateRange[0]?.format('YYYY-MM-DD') || ''}-${dateRange[1]?.format('YYYY-MM-DD') || ''}`;
  }, [currentPage, reportsPerPage, searchQuery, selectedFilter, filterValue, dateRange]);

  const filterOptions = {
    brand: [],
    model: [],
    grade: [],
    inStock: ['true', 'false'],
    status: ['Completed', 'Not Completed'],
    partially: ['Yes', 'No'],
  };
  // Fetch reports from the API with pagination and filters
  const fetchReports = async (page = currentPage, search = searchQuery, selectedFilt = filterValue, dateFilter = dateRange, checkedFilter=activeFilter) => {
    try {
      setLoading(true);

      // Check cache first
      const cacheKey = `${page}-${reportsPerPage}-${search}-${selectedFilt || ''}-${dateFilter[0]?.format('YYYY-MM-DD') || ''}-${dateFilter[1]?.format('YYYY-MM-DD') || ''}`;

      if (pageCache.has(cacheKey)) {
        const cachedData = pageCache.get(cacheKey);
        setReports(cachedData.reports);
        setTotalReports(cachedData.totalReports);
        setLoading(false);
        return;
      }
      let profilesFilters = {
        'GV Post-Repair QC Testing with Datawipe': 'profileName',
        'GV-Receiving': 'profileName',
        'blackbelt':'status',
        'kiosk':'partially'

      }
      const params = {
        page,
        limit: reportsPerPage,
        selectedFilter: profilesFilters[checkedFilter || selectedFilter || selectedFilt],
        status: selectedFilt == 'clear' ? null : selectedFilt,
        profileName:selectedFilt
        
      };
      // Add search query if present
      if (search && search.trim()) {
        params.search = search.trim();
      }

      // Add date range if present
      if (dateFilter[0] && dateFilter[1]) {
        params.startDate = dateFilter[0].format('YYYY-MM-DD');
        params.endDate = dateFilter[1].format('YYYY-MM-DD');
      }

      const response = await axios.get('/api/reports', { params });

      // Process reports data with proper null/undefined handling
      const fetchedReports = response.data.reports.map((report, index) => ({
        fullData: report,
        reportId: report.data?.report?.reportid || `unknown-${index}`,
        reportDate: report.data?.report?.finishtime || report.timestamp || '',
        imei: report.data?.report?.IMEI || report.data?.extra?.json?.DeviceInfo?.IMEI || 'N/A',
        brand: report.data?.report?.Manufacturer || 'N/A',
        model: report.data?.report?.Model || 'N/A',
        value: report.data?.report?.value || 'N/A',
        grade: report.data?.report?.grade || 'N/A',
        status: report.data?.report?.reportstatus || 'N/A',
        action: report.data?.report?.action || 'N/A',
        result: report.data?.report?.reportresult || 'N/A',
        uniqueId: report._id || `${report.data?.report?.reportid}-${index}`,
      }));

      setReports(fetchedReports);
      setTotalReports(response.data.totalReports);

      // Cache the results
      setPageCache(prev => {
        const newCache = new Map(prev);
        newCache.set(cacheKey, {
          reports: fetchedReports,
          totalReports: response.data.totalReports
        });

        // Limit cache size to prevent memory issues (keep last 20 pages)
        if (newCache.size > 20) {
          const firstKey = newCache.keys().next().value;
          newCache.delete(firstKey);
        }

        return newCache;
      });

      // Initialize checkbox state
      const initialCheckedState = fetchedReports.reduce((acc, report) => {
        acc[report.uniqueId] = false;
        return acc;
      }, {});
      setCheckedItems(initialCheckedState);

      console.log("Fetched Reports", fetchedReports);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching reports:', error);
      setLoading(false);
      message.error('Failed to fetch reports');
    }
  };

  const fetchFileNames = async () => {
    try {
      const response = await axios.get("/api/get-images");
      const fileNames = response.data || [];
      setKisokData(fileNames);
    } catch (err) {
      console.error("Error fetching file names:", err);
    }
  }
  const fetchDashboardReports = async (params) => {
  try {
    const response = await axios.get("/api/all/reports/dashboard");
    setPushReports(response?.data.reports || [])
  } catch (error) {
    console.error("Error fetching dashboard reports:", error);
    // You can throw again or return a fallback value depending on your use case
    throw error;
  }
};


  // Initial load
  useEffect(() => {
    fetchReports();
    fetchFileNames();
    fetchDashboardReports()

  }, []);

  
  // Handle search with debounce
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    // Clear existing timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Set new timeout for debounced search
    const newTimeout = setTimeout(() => {
      setCurrentPage(1); // Reset to first page
      setPageCache(new Map()); // Clear cache when search changes
      fetchReports(1, value, filterValue, dateRange);
    }, 500); // 500ms debounce

    setSearchTimeout(newTimeout);
  };

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchReports(page, searchQuery, filterValue, dateRange);
  };

  // Handle sort order change
  const handleSortChange = (order) => {
    setSortOrder(order);
    setCurrentPage(1);
    setPageCache(new Map()); // Clear cache when sort changes
    fetchReports(1, searchQuery, order, dateRange);
  };

  // Handle date range change
  const handleDateRangeChange = (dates) => {
    setDateRange(dates || [null, null]);
    setCurrentPage(1);
    setPageCache(new Map()); // Clear cache when date range changes
    fetchReports(1, searchQuery, filterValue, dates || [null, null]);
  };

  // Function to clear all filters
  const clearFilters = () => {
    setSearchQuery('');
    setDateRange([null, null]);
    setSortOrder('desc');
    setCurrentPage(1);
    setSelectedFilter(null);
    setFilterValue(null);
    setPageCache(new Map()); // Clear cache when filters are cleared
    fetchReports(1, '', filterValue, [null, null]);
  };

  // Function to format date for display
  // const formatDate = (dateString) => {
  //   return moment(dateString).format('YYYY-MM-DD HH:mm:ss');
  // };

  const formatDate = (dateString) => {
    return moment(dateString).format('YYYY-MM-DD hh:mm:ss A'); // 12-hour format with AM/PM
  };

  //Push to Transaction Reports
  const handlePushToReports = async (report) => {
    console.log("Data to be pushed:", report.fullData);
    
    try {
      const response = await axios.post('/api/report/push', { data: report.fullData });
      console.log("Push response:", response.data);
      message.success(response.data.message);
    } catch (error) {
      console.error("Push failed:", error.response?.data || error);
      message.error(error.response?.data?.message || 'Failed to push data');
    }
  };

  // const showConfirmModal = (report) => {
  //   Modal.confirm({
  //     title: 'Confirm Push to Reports',
  //     icon: <ExclamationCircleOutlined />,
  //     content: (
  //       <div>
  //         <p>Please confirm before pushing this report:</p>
  //         <p><strong>Check: iCloud blocked and MDN blocked</strong></p>
  //       </div>
  //     ),
  //     okText: 'Push to Reports',
  //     okButtonProps: {
  //       style: {
  //         backgroundColor: '#ce2e28',
  //         borderColor: '#ce2e28',
  //         color: '#ffffff',
  //       },
  //     },
  //     cancelText: 'Cancel',
  //     onOk() {
  //       handlePushToReports(report);
  //     },
  //     onCancel() {
  //       // Modal closes automatically
  //     },
  //   });
  // };

  const showConfirmModal = (report) => {
   let foundPushReport = pushReports.find(r => r.data?.report?.IMEI === report.imei);
   if (foundPushReport) {
    return message.error('This report has already been pushed to Transactions.');
   }
  Modal.confirm({
    title: 'Confirm Push to Reports',
    icon: <ExclamationCircleOutlined />,
    content: (
      <div>
        <p>Please confirm before pushing this report:</p>
        <ul>
          <li><strong>Date:</strong> {report.reportDate}</li>
          <li><strong>Device:</strong> {report.brand} {report.model}</li>
          <li><strong>IMEI:</strong> {report.imei}</li>
        </ul>
      </div>
    ),
    okText: 'Push to Reports',
    okButtonProps: {
      style: {
        backgroundColor: '#ce2e28',
        borderColor: '#ce2e28',
        color: '#ffffff',
      },
    },
    cancelText: 'Cancel',
    onOk() {
      handlePushToReports(report);
    },
    onCancel() {
      // Modal closes automatically
    },
  });
};

  const handleFilterChange = (value) => {
    if (!value) {
      setSelectedFilter('');
      setFilterValue('');
      fetchReports(1, searchQuery, 'clear', dateRange || [null, null]);
      setPageCache(new Map()); // Clear cache when sort changes
     
    } else {
      if (activeFilter) {
         setActiveFilter('')
         setBlackbeltChecked('')
         setKioskChecked('')

      }
      setSelectedFilter(value)
      setFilterValue(value);
      setCurrentPage(1);
      setPageCache(new Map()); // Clear cache when sort changes

      fetchReports(1, searchQuery, value, dateRange, null);
    }
    // Trigger filtering logic here if needed
  };

  const fetchReportImages = async (imei) => {
    setImageLoading(true);
    setImageError('');
    if (!imei) {
      setSelectedImages([]);
      setImageLoading(false);
      setImageError('No IMEI provided.');
      return;
    }
    const imageNames = [
      'Back', 'Behind', 'Font_LightAngle1', 'Font_LightAngle2', 'Font_LightAngle3',
      'Font_LightAngle4', 'Font_LightAngle5', 'Font_LightAngle6', 'Font_LightAngle7',
      'Font_LightAngle8', 'Front'
    ];
    let loadedImages = [];
    let checkedCount = 0;
    const totalImages = imageNames.length;

    imageNames.forEach((name, idx) => {
      const webpUrl = `https://report.gearvu.io/kiosk-image/downloaded_files/${imei}/${name}.webp`;
      const jpgUrl = `https://report.gearvu.io/kiosk-image/downloaded_files/${imei}/${name}.jpg`;
      const tempImage = new window.Image();
      tempImage.onload = () => {
        loadedImages[idx] = {
          original: webpUrl,
          thumbnail: jpgUrl,
          fallback: jpgUrl,
          alt: name.replace(/_/g, ' ')
        };
        checkedCount++;
        if (checkedCount === totalImages) finish();
      };
      tempImage.onerror = () => {
        const fallbackImage = new window.Image();
        fallbackImage.onload = () => {
          loadedImages[idx] = {
            original: jpgUrl,
            thumbnail: jpgUrl,
            fallback: jpgUrl,
            alt: name.replace(/_/g, ' ')
          };
          checkedCount++;
          if (checkedCount === totalImages) finish();
        };
        fallbackImage.onerror = () => {
          checkedCount++;
          if (checkedCount === totalImages) finish();
        };
        fallbackImage.src = jpgUrl;
      };
      tempImage.src = webpUrl;
    });

    function finish() {
      const validImages = loadedImages.filter(Boolean);
      setSelectedImages(validImages);
      setImageLoading(false);
      if (validImages.length === 0) {
        setImageError('Image data missing or incomplete. No device images found or processed.');
      }
    }
  }

  const renderGalleryImage = (image) => (
    <img
      src={image.original}
      alt={image.alt}
      style={{
        width: '100%',
        maxHeight: '400px',
        objectFit: 'contain',
        background: '#fff'
      }}
      onError={e => { e.target.src = image.fallback; }}
    />
  );
  const modalId = useMemo(() => `image-modal-${Math.random().toString(36).substr(2, 9)}`, []);
  useEffect(() => {
    if (isImageModalVisible) {
      const styleId = `custom-image-gallery-styles-${modalId}`;
      let style = document.getElementById(styleId);

      if (!style) {
        style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          /* Only target this specific modal instance */
          #${modalId} .image-gallery.fullscreen .image-gallery-thumbnails {
            display: none !important;
          }
          
          #${modalId} .image-gallery.fullscreen {
            height: 100dvh !important;
            width: 100vw !important;
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            z-index: 9999 !important;
            background: black !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
          }
          
          #${modalId} .image-gallery.fullscreen .image-gallery-content {
            height: calc(100vh - 20px) !important;
            width: 100vw !important;
            position: relative !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0 !important;
            padding: 10px !important;
            box-sizing: border-box !important;
          }
          
          #${modalId} .image-gallery.fullscreen .image-gallery-slides-container {
            height: 100% !important;
            width: 100% !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
          
          #${modalId} .image-gallery.fullscreen .image-gallery-slides {
            height: 100% !important;
            width: 100% !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
          
          #${modalId} .image-gallery.fullscreen .image-gallery-slide {
            height: 100% !important;
            width: 100% !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          
          #${modalId} .image-gallery.fullscreen .image-gallery-image {
            height: 100% !important;
            width: 100% !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          
          #${modalId} .image-gallery.fullscreen .image-gallery-slide img {
            max-height: calc(100vh - 40px) !important;
            max-width: calc(100vw - 40px) !important;
            width: auto !important;
            height: auto !important;
            object-fit: contain !important;
            margin: 0 !important;
            padding: 0 !important;
            position: static !important;
          }
          
          /* Hide all controls in fullscreen except navigation arrows */
          #${modalId} .image-gallery.fullscreen .image-gallery-thumbnails-wrapper {
            display: none !important;
          }
          
          #${modalId} .image-gallery.fullscreen .image-gallery-play-button {
            display: none !important;
          }
          
          #${modalId} .image-gallery.fullscreen .image-gallery-fullscreen-button {
            top: 20px !important;
            right: 20px !important;
            z-index: 10000 !important;
          }
          
          #${modalId} .image-gallery .image-gallery-slide img {
            max-width: 100%;
            max-height: 500px;
            object-fit: contain;
          }
        `;
        document.head.appendChild(style);
      }
    }

    return () => {
      // Clean up styles when modal closes
      const style = document.getElementById(`custom-image-gallery-styles-${modalId}`);
      if (style) {
        style.remove();
      }
    };
  }, [isImageModalVisible, modalId]);
  // const naviage = Navigate()
  //  const handleNavigationToReport2 = ()=>{
  //     // naviage('/https://report.gearvu.io/report-temp/');
  //     naviage('https://report.gearvu.io/report-temp/?=certified#');
  //   }

const handleCheckboxFilter = (filterType) => {
  if (activeFilter === filterType) {
    // case: clicking the same checkbox -> reset to default values
    setActiveFilter(null);
    setSelectedFilter("GV Post-Repair QC Testing with Datawipe");
    setFilterValue("GV Post-Repair QC Testing with Datawipe");
    setCurrentPage(1);
    setPageCache(new Map());
    fetchReports(1, searchQuery, 'GV Post-Repair QC Testing with Datawipe', dateRange, null);
  } else {
    // case: selecting a new checkbox
    setActiveFilter(filterType);
    setSelectedFilter("");
    setFilterValue("");
    setCurrentPage(1);
    setPageCache(new Map());
    fetchReports(1, searchQuery, filterType, dateRange, filterType);
  }
};
  return (
    <>

      <Modal
        open={isImageModalVisible}
        onCancel={() => setIsImageModalVisible(false)}
        footer={null}
        width={'50%'}
        bodyStyle={{
          minHeight: 620,
          maxHeight: '60%',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        centered
      >
        <div
          id={modalId}
          style={{
            width: '100%',
            paddingTop: '1rem',
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
          }}
        >
          <div style={{
            width: '100%',
            height: '80%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {imageLoading ? (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 600
              }}>
                <img src={require('../Report/assets/report-loading.gif')} alt="Loading..." />
              </div>
            ) : selectedImages?.length === 0 ? (
              <div style={{
                backgroundColor: '#f8d7da',
                color: '#721c24',
                border: '1px solid #f5c6cb',
                borderRadius: '0.375rem',
                padding: '0.75rem 1.25rem',
                display: 'flex',
                alignItems: 'center',
                margin: '1rem'
              }}>
                <i
                  className="fa-solid fa-triangle-exclamation"
                  style={{
                    fontSize: '24px',
                    marginRight: '10px'
                  }}
                ></i>
                <span>Image data missing or incomplete. No device images found or processed.</span>
              </div>
            ) : (
              <ImageGallery
                items={selectedImages?.map((image) => ({
                  ...image,
                  renderItem: () => (
                    <img
                      src={image.original}
                      alt={image.alt}
                      onError={e => { e.target.src = image.fallback; }}
                      style={{
                        maxWidth: '90%',
                        maxHeight: '90%',
                        objectFit: 'contain'
                      }}
                    />
                  )
                }))}
                showThumbnails={true}
                showFullscreenButton={true}
                showPlayButton={false}
                thumbnailPosition="bottom"
                lazyLoad={true}
              />
            )}
          </div>
        </div>
      </Modal>
      {/* <ResponsiveImageModal 
          isImageModalVisible={isImageModalVisible} 
          setIsImageModalVisible={setIsImageModalVisible}
          imageLoading={imageLoading}
          imageError={imageError}
          selectedImages={selectedImages}
          /> */}
      <div className="App">
        <div className="dashboard">
          <div className="container-fluid">
            <div className="row">
              <Sidebar />
              <div className="col-md-10 main">
                <h1 className="page-heading" >All Transactions</h1>
                <div style={{ marginBottom: '20px' }}>
                  {/* Search Bar Row */}
                  <Row gutter={[16, 16]} align="start" justify="space-between">
                    {/* Search */}
                    <Col xs={24} sm={12} md={8}>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <img src={search} alt="Search" />
                          </span>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search IMEI, Re_ID, Brand, Model"
                          value={searchQuery}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </Col>





                    <Col xs={24} sm={12} md={8}>
                      <div className="input-group" >

                        <RangePicker
                          onChange={handleDateRangeChange}
                          format="YYYY-MM-DD"
                          placeholder={['Start Date', 'End Date']}
                          value={dateRange}
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={18} md={5} style={{ marginTop: 7 }}>

                      <Select
                        
                        placeholder="Select Filter"
                        value={selectedFilter}
                        // allowClear
                        onChange={(val) => {
                          if (!val) {
                            // Clear both selectedFilter and filterValue
                            setSelectedFilter('');
                            setFilterValue('');
                            // Optional: refetch all reports
                            handleFilterChange(val);

                            fetchReports(1, searchQuery, '', dateRange || [null, null]);
                            
                            
                          } else {
                            setSelectedFilter(val);
                            handleFilterChange(val)
                          }
                        }}
                      >
                        {/* <Option value="brand">Brand</Option> */}
                        {/* <Option value="model">Model</Option> */}
                        {/* <Option value="grade">Grade</Option> */}
                        {/* <Option value="inStock">In Stock</Option> */}
                        {/* <Option value="status">Status</Option> */}
                        {/* <Option value="action">Action</Option> */}
                        {/* <Option value="partially">Parital Data</Option> */}
                        <Option value="GV Post-Repair QC Testing with Datawipe">GV Post-Repair QC Testing with Datawipe</Option>
                        <Option value="GV-Receiving">GV Receiving</Option>
                      </Select>

                      {/* {selectedFilter && (

                        <Select
                          placeholder={`Select ${selectedFilter}`}
                          allowClear
                          value={filterValue}
                          onChange={(value) => {
                            handleFilterChange(value);
                          }}
                          style={{ width: '100%' }}
                          options={
                            filterOptions[selectedFilter]?.map((option) => ({
                              label: option,
                              value: option
                            })) || []
                          }
                        />

                      )} */}
                    </Col>

                    {/* <Col xs="auto">
                      <Button
                        onClick={clearFilters}
                        style={{
                          fontWeight: 'bold',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        Clear Filters
                      </Button>
                    </Col> */}
                  </Row>

                </div>


                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                  <Checkbox
                     checked={activeFilter === "kiosk"}
                  onChange={(e) =>
                    handleCheckboxFilter("kiosk", e.target.checked)
                  }
                  >
                    Kiosk
                  </Checkbox>

                    <Checkbox
                       checked={activeFilter === "blackbelt"}
                      onChange={(e) =>
                        handleCheckboxFilter("blackbelt", e.target.checked)
                      }
                    >
                      Blackbelt
                    </Checkbox>
                </div>

                <section className="reports">
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-12">
                        <div className="table-responsive webhoooks-reports-table">
                          <Spin spinning={loading || isGhlLoading} size="large" wrapperClassName="custom-spin">
                            <table className="table table-striped table-bordered align-items-center">
                              <thead>
                                <tr>
                                  <th>Report ID</th>
                                  <th>
                                    Date/Time
                                    {sortOrder === 'desc' ?
                                      <SortDescendingOutlined style={{ marginLeft: 8, color: '#1890ff' }} /> :
                                      <SortAscendingOutlined style={{ marginLeft: 8, color: '#1890ff' }} />
                                    }
                                  </th>
                                  <th>IMEI</th>
                                  <th>Brand</th>
                                  <th>Model</th>
                                  {/* <th>Grade</th> */}
                                  <th>Kiosk</th>
                                  <th>Blackbelt</th>
                                  <th>Status</th>
                                  {/* <th>Result</th> */}
                                  <th>View</th>
                                  <th>View Images</th>
                                  <th>Push Data</th>
                                  {/* <th>Report 2.0</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {reports.length > 0 ? (
                                  reports.map((report) => {

                                    let found = publishedReports?.find((rep) => report?.imei === rep?.imei);

                                    return (
                                      <tr key={report.uniqueId}>
                                        <td>{report.reportId}</td>
                                        <td>{formatDate(report.reportDate)}</td>
                                        <td>{report.imei}</td>
                                        <td>{report.brand}</td>
                                        <td>{report.model}</td>
                                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                          {kiostData.includes(report?.imei) ? (
                                            <CheckCircleOutlined style={{ color: 'green', fontSize: '18px' }} />
                                          ) : (
                                            <CloseCircleOutlined style={{ color: 'red', fontSize: '18px' }} />
                                          )}
                                        </td>
                                        <td>
                                          {report.status === 'Completed' ? (
                                            <CheckCircleOutlined style={{ color: 'green', fontSize: '18px' }} />
                                          ) : (
                                            <CloseCircleOutlined style={{ color: 'red', fontSize: '18px' }} />
                                          )}
                                        </td>
                                        <td>{report.action}</td>

                                        {/* <td>
                                        <span className={`result-badge result-${report.result.toLowerCase().replace(/\s+/g, '-')}`}>
                                          {report.result}
                                        </span>
                                      </td> */}
                                        <td>
                                          <Tooltip title="View Report">
                                            <span>
                                              <Button
                                                type="link"
                                                icon={<EyeOutlined />}
                                                onClick={() => window.open(`/webhook/report/${report.fullData._id}`, '_blank')}
                                              />
                                            </span>
                                          </Tooltip>
                                        </td>
                                        <td>
                                          <Button
                                            type="link"
                                            className="simple-btn"
                                            onClick={() => {
                                              setIsImageModalVisible(true);
                                              fetchReportImages(report.imei);
                                            }}
                                          >
                                            Images
                                          </Button>
                                        </td>
                                        <td>

                                          <Button
                                            style={{ width: '100%' }}
                                            className="simple-btn"
                                            onClick={() =>{
                                              showConfirmModal(report)}}
                                          // disabled={
                                          //   report?.fullData?.isPartial === true ||
                                          //   publishedReports.some(p => p._id === report?.fullData?._id)
                                          // }
                                          >
                                            Add To Reports
                                          </Button>
                                        </td>


                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td colSpan="11" style={{ textAlign: 'center', padding: '20px' }}>
                                      <Empty
                                        description={
                                          searchQuery || (dateRange[0] && dateRange[1])
                                            ? "No reports found matching your filters"
                                            : "Oops! No reports found!"
                                        }
                                      />
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </Spin>
                        </div>
                        {/* Pagination */}

                        {totalReports > reportsPerPage && (
                          <div className='table-bottom-webhook-reports' style={{
                            display: 'flex',
                            marginTop: '20px'

                          }}>
                            <div>

                              <Pagination
                                current={currentPage}
                                total={totalReports}
                                pageSize={reportsPerPage}
                                onChange={handlePageChange}
                                showSizeChanger={false}
                                showTotal={(total, range) =>
                                  `${range[0]}-${range[1]} of ${total} reports`
                                }
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div>
        </div>
      </div >
    </>
  );
}

export default WebHookDeviceReports;























{/* <Modal
        open={isImageModalVisible}
        onCancel={() => setIsImageModalVisible(false)}
        footer={null}
        width={'60%'}

        bodyStyle={{
          minHeight: 620,
          maxHeight: '50%',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        centered
      >
        <div className="row pt-3" style={{ width: '100%' }} >
          <div className="img-box" style={{ width: '100%', height: '100%' }}>


            {imageLoading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
                <img src={require('../Report/assets/report-loading.gif')} alt="Loading..." />
              </div>
            ) : selectedImages?.length === 0 ? (
              <div className="alert alert-danger d-flex align-items-center" role="alert">
                <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: '24px', marginRight: '10px' }}></i>
                <span>Image data missing or incomplete. No device images found or processed.</span>
              </div>
            ) : (

              <ImageGallery

                items={selectedImages?.map((image) => ({
                  ...image,
                  renderItem: () => (
                    <img
                      src={image.original}
                      alt={image.alt}
                      onError={e => { e.target.src = image.fallback; }}
                    />
                  )
                }))}

                showThumbnails={true}
                showFullscreenButton={true}
                showPlayButton={false}
                thumbnailPosition="bottom"
                lazyLoad={true}
              />
            )
            }

          </div>
        </div>

      </Modal> */}